// extracted by mini-css-extract-plugin
export default {"tag":"UserOrgSwitch_tag__EfCYp","tagLabel":"UserOrgSwitch_tagLabel__1lrRe","active":"UserOrgSwitch_active__bTTXc"};